import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';

const statusDotVariants = cva('inline-block shrink-0 rounded-full', {
  variants: {
    /** Statusy z legendy drabinki turniejowej. */
    status: {
      finished: 'bg-status-finished',
      live: 'bg-status-live',
      suspended: 'bg-status-suspended',
      scheduled: 'bg-status-scheduled',
      walkover: 'bg-status-walkover',
      retired: 'bg-status-retired',
      idle: 'bg-status-idle',
    },
    size: {
      sm: 'size-1.5',
      md: 'size-2',
      lg: 'size-2.5',
    },
    /**
     * Powolne pulsowanie — znak, ze cos dzieje sie teraz (mecz w trakcie).
     * `motion-reduce` je wylacza: kropka zostaje, tylko przestaje migac.
     */
    pulse: {
      true: 'animate-status-pulse motion-reduce:animate-none',
      false: '',
    },
  },
  defaultVariants: {
    status: 'idle',
    size: 'md',
    pulse: false,
  },
});

export interface StatusDotProps
  extends ComponentPropsWithRef<'span'>,
    VariantProps<typeof statusDotVariants> {
  /** Opis statusu dla czytnikow ekranu, gdy obok nie ma widocznego tekstu. */
  label?: string;
}

/** Kolorowa kropka statusu meczu lub kortu. */
export function StatusDot({ className, status, size, pulse, label, ...props }: StatusDotProps) {
  return (
    <>
      <span
        aria-hidden="true"
        className={cn(statusDotVariants({ status, size, pulse }), className)}
        {...props}
      />
      {label && <span className="sr-only">{label}</span>}
    </>
  );
}
